import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ImagesPreview } from 'src/app/pages/movements/components/selector-movement-images/selector-movement-images.component';
import { LocalStorageManager } from '../../../utils/local-storage-manager/local-storage-manager.utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-preview-image',
  templateUrl: './modal-preview-image.component.html',
  styleUrls: ['./modal-preview-image.component.css']
})
export class ModalPreviewImageComponent implements OnInit {

  @Input() modalId: string = "app-modal-preview-image"
  @Input() image!: ImagesPreview;

  @Output() remove = new EventEmitter<ImagesPreview>();

  isDarkmode = LocalStorageManager.isDarkmode;

  constructor(private translate: TranslateService) {
    let lang = LocalStorageManager.lang;
    this.translate.use(lang!);
   }

  ngOnInit(): void { }

  removeImage() {
    this.remove.emit(this.image);
    this.closeModal();
  }

  closeModal() {
    document.getElementById(this.modalId)?.click();
  }

}
